import { useState, useEffect, useRef, createContext, useContext } from "react";

// ─── GA4 TRACKING ────────────────────────────────────────────────────────────
const trackEvent = (eventName, params = {}) => {
  if (typeof window.gtag !== "undefined") {
    window.gtag("event", eventName, params);
  }
};

const COLORS = {
  dark: "#013E6E",
  mid: "#587890",
  light: "#D4E4F0",
  gray: "#E5E5E5",
  text: "#444444",
  textLight: "#888888",
};

// ─── HOOK RESPONSIVE ────────────────────────────────────────────────────────
function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const fn = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);
  return isMobile;
}

// ─── TRADUCCIONS / TRADUCCIONES ─────────────────────────────────────────────
const T = {
  ca: {
    nav: {
      serveis: "Serveis", comFunciona: "Com funciona", plans: "Paquets", contacte: "Contacte", cta: "Parlem",
    },
    hero: {
      badge: "Castelldefels · Gavà · Viladecans",
      h1: <>Quan la tecnologia<br/>pot ser<br/>un problema per a tu,<br/>estem <span style={{ color: "#D4E4F0" }}>nosaltres</span><br/>per donar-te un<br/>cop de mà.</>,
      cta1: "Contacta'ns", cta2: "Descobreix més",
      cards: [
        { icon: "⚡", title: "Estalvia temps", desc: "Automatitza les tasques repetitives del teu negoci." },
        { icon: "📱", title: "Controla el teu espai", desc: "Gestiona el teu local des del mòbil, estiguis on estiguis." },
        { icon: "🛡️", title: "Tranquil·litat", desc: "Una persona de confiança quan la tecnologia falla." },
        { icon: "💬", title: "Comunica't", desc: "Els teus clients, sempre informats i connectats." },
      ],
    },
    about: {
      label: "Qui som",
      h2: <>TechFels és una persona,<br/>no una empresa.</>,
      p1: "Tens un problema tecnològic i no saps a qui trucar? Treballem amb negocis i llars de Castelldefels, Gavà i Viladecans ajudant-los amb tot allò tecnològic: des d'un Excel que no funciona fins a la configuració completa d'un local.",
      p2: "Som el teu interlocutor tecnològic de confiança. Sempre la mateixa persona, que coneix el teu negoci i hi és quan la necessites.",
      tags: ["Sense contractes", "Sense permanències", "Sempre a prop"],
    },
    services: {
      label: "Serveis", h2: "El teu negoci i el teu espai, sota control.",
      closing: "Tot això sense haver d'entendre gaire de tecnologia.",
      items: [
        { icon: "/icon_time.png", title: "Estalvia temps", desc: "Allò que fas manualment cada dia — recordatoris, seguiments, enviaments — ho automatitzem perquè passi sol, sense que hagis de fer res." },
        { icon: "/icon_comm.png", title: "Comunica't", desc: "Els teus clients reben la informació que necessiten, en el moment adequat. Sense esforç per part teva, i amb una imatge professional." },
        { icon: "/icon_control.png", title: "Controla el teu espai", desc: "Llum, música i temperatura adaptats al moment del dia i al teu negoci. Tot des del mòbil, estiguis on estiguis. Els teus clients ho notaran." },
        { icon: "/icon_tranquil.png", title: "Tranquil·litat", desc: "Quan alguna cosa falla, no has de buscar a qui trucar. Tens una persona de confiança que coneix el teu negoci i que hi és quan la necessites." },
      ],
    },
    how: {
      label: "És molt senzill", h2: "Un servei professional, solvent i proper.",
      steps: [
        { n: "01", title: "Contacta", desc: "Truca'ns, escriu-nos o passa't sense compromís." },
        { n: "02", title: "Explica", desc: "T'escoltem i proposem la millor solució per al teu negoci o llar." },
        { n: "03", title: "Tenim la solució", desc: "Tu te n'oblides, nosaltres ho solucionem." },
      ],
    },
    pricing: {
      label: "Paquets", h2: "Aposta per nosaltres", sub: "Transparent i sense sorpreses",
      plans: [
        { name: "Per hores", detail: "Fraccions de 30 min · Sense compromís previ", highlight: false },
        { name: "Bono de minuts", detail: "120 minuts prepagats · Ideal per a tasques freqüents", highlight: true },
        { name: "Projecte tancat", detail: "Preu acordat abans de començar · Resultat garantit", highlight: false },
      ],
      footer: "Sense permanències",
    },
    cookies: {
  title: "Utilitzem cookies",
  text: "Fem servir cookies pròpies i de tercers (Google Analytics) per analitzar el trànsit i millorar la teva experiència. Pots acceptar-les o rebutjar-les.",
  accept: "Acceptar",
  reject: "Rebutjar",
  moreInfo: "Més informació",
  // Modal privacitat
  privacyTitle: "Política de Privacitat i Cookies",
  privacyContent: `
    <h3>1. Responsable del tractament</h3>
    <p>TechFels · hola@techfels.es · Castelldefels, Barcelona</p>
    <h3>2. Finalitat</h3>
    <p>Les dades recollides mitjançant el formulari de contacte s'utilitzen exclusivament per respondre les teves consultes. No es cedeixen a tercers.</p>
    <h3>3. Cookies</h3>
    <p>Aquesta web utilitza Google Analytics (cookies analítiques) per obtenir estadístiques anònimes de visites. Només s'activen amb el teu consentiment.</p>
    <h3>4. Drets</h3>
    <p>Pots exercir els teus drets d'accés, rectificació, supressió i oposició escrivint a hola@techfels.es.</p>
    <h3>5. Més informació</h3>
    <p>Per a més detalls consulta la nostra política completa o escriu-nos a hola@techfels.es.</p>
  `,
  close: "Tancar",
},
    contact: {
      label: "Contacte", h2: "Parlem.",
      sub: "Sense compromís. Explica'ns el teu problema i et direm com podem ajudar-te.",
     items: [
  { icon: "📞", label: "+34 684797403", sub: "Truca'ns directament", type: "phone" },
  { icon: "💬", label: "+34 684797403", sub: "WhatsApp", type: "whatsapp" },
  { icon: "✉️", label: "hola@techfels.es", sub: "Et responem en menys de 24h", type: "email" },
  { icon: "🌐", label: "www.techfels.es", sub: "La nostra web", type: "web" },
  { icon: "📍", label: "Castelldefels · Gavà · Viladecans", sub: "Zona de servei", type: null },
],
      formTitle: "Envia'ns un missatge", nameLabel: "Nom", namePlaceholder: "El teu nom",
      msgLabel: "Missatge", msgPlaceholder: "Explica'ns com podem ajudar-te...",
      submit: "Envia el missatge", sending: "Enviant...",
      successTitle: "Missatge enviat!", successSub: "Et respondrem aviat", errorMsg: "Omple tots els camps",
      sendErrorMsg: "Hi ha hagut un error en l'enviament. Torna-ho a intentar.",

    },
    footer: { tagline: "Tecnologia de proximitat", copy: "Castelldefels · Gavà · Viladecans · Sense contractes" },
  },
  en: {
    nav: {
      serveis: "Services", comFunciona: "How it works", plans: "Plans", contacte: "Contact", cta: "Let's talk",
    },
    hero: {
      badge: "Castelldefels · Gavà · Viladecans",
      h1: <>When technology<br/>can become<br/>a problem for you,<br/>we're <span style={{ color: "#D4E4F0" }}>here</span><br/>to give you<br/>a hand.</>,
      cta1: "Contact us", cta2: "Discover more",
      cards: [
        { icon: "⚡", title: "Save time", desc: "Automate the repetitive tasks of your business." },
        { icon: "📱", title: "Control your space", desc: "Manage your premises from your phone, wherever you are." },
        { icon: "🛡️", title: "Peace of mind", desc: "A trusted person when technology fails." },
        { icon: "💬", title: "Communicate", desc: "Your clients, always informed and connected." },
      ],
    },
    about: {
      label: "Who we are",
      h2: <>TechFels is a person,<br/>not a company.</>,
      p1: "Got a tech problem and don't know who to call? We work with businesses and homes in Castelldefels, Gavà and Viladecans, helping them with everything tech-related: from a spreadsheet that won't work to the full setup of a premises.",
      p2: "We are your trusted technology partner. Always the same person, who knows your business and is there when you need them.",
      tags: ["No contracts", "No lock-ins", "Always nearby"],
    },
    services: {
      label: "Services", h2: "Your business and your space, under control.",
      closing: "All of this without needing to understand much about technology.",
      items: [
        { icon: "/icon_time.png", title: "Save time", desc: "What you do manually every day — reminders, follow-ups, sending messages — we automate it so it happens on its own, without you having to do anything." },
        { icon: "/icon_comm.png", title: "Communicate", desc: "Your clients receive the information they need, at the right time. No effort on your part, and with a professional image." },
        { icon: "/icon_control.png", title: "Control your space", desc: "Lighting, music and temperature adapted to the time of day and your business. All from your phone, wherever you are. Your clients will notice." },
        { icon: "/icon_tranquil.png", title: "Peace of mind", desc: "When something fails, you don't have to look for who to call. You have a trusted person who knows your business and is there when you need them." },
      ],
    },
    how: {
      label: "It's very simple", h2: "A professional, reliable and personal service.",
      steps: [
        { n: "01", title: "Contact", desc: "Call us, write to us or drop by with no commitment." },
        { n: "02", title: "Explain", desc: "We listen and propose the best solution for your business or home." },
        { n: "03", title: "We have the solution", desc: "You forget about it, we sort it out." },
      ],
    },
    pricing: {
      label: "Plans", h2: "Bet on us", sub: "Transparent and no surprises",
      plans: [
        { name: "Hourly", detail: "30 min increments · No prior commitment", highlight: false },
        { name: "Minute bundle", detail: "120 prepaid minutes · Ideal for frequent tasks", highlight: true },
        { name: "Fixed project", detail: "Price agreed before starting · Result guaranteed", highlight: false },
      ],
      footer: "No lock-ins",
    },cookies: {
  title: "We use cookies",
  text: "We use our own and third-party cookies (Google Analytics) to analyse traffic and improve your experience. You can accept or reject them.",
  accept: "Accept",
  reject: "Reject",
  moreInfo: "More information",
  privacyTitle: "Privacy & Cookie Policy",
  privacyContent: `
    <h3>1. Data controller</h3>
    <p>TechFels · hola@techfels.es · Castelldefels, Barcelona</p>
    <h3>2. Purpose</h3>
    <p>Data collected through the contact form is used exclusively to respond to your enquiries. It is not shared with third parties.</p>
    <h3>3. Cookies</h3>
    <p>This website uses Google Analytics (analytical cookies) to obtain anonymous visit statistics. They are only activated with your consent.</p>
    <h3>4. Rights</h3>
    <p>You can exercise your rights of access, rectification, deletion and objection by writing to hola@techfels.es.</p>
    <h3>5. More information</h3>
    <p>For more details write to us at hola@techfels.es.</p>
  `,
  close: "Close",
},
    contact: {
      label: "Contact", h2: "Let's talk.",
      sub: "No commitment. Tell us your problem and we'll tell you how we can help.",
      items: [
        { icon: "📞", label: "+34 684797403", sub: "Call us directly", type: "phone" },
        { icon: "💬", label: "+34 684797403", sub: "WhatsApp", type: "whatsapp" },
        { icon: "✉️", label: "hola@techfels.es", sub: "We reply within 24h", type: "email" },
        { icon: "🌐", label: "www.techfels.es", sub: "Our website", type: "web" },
        { icon: "📍", label: "Castelldefels · Gavà · Viladecans", sub: "Service area", type: null },
      ],
      formTitle: "Send us a message", nameLabel: "Name", namePlaceholder: "Your name",
      msgLabel: "Message", msgPlaceholder: "Tell us how we can help you...",
      submit: "Send message", sending: "Sending...",
      successTitle: "Message sent!", successSub: "We'll get back to you soon", errorMsg: "Please fill in all fields",
      sendErrorMsg: "There was an error sending. Please try again.",
    },
    footer: { tagline: "Local technology", copy: "Castelldefels · Gavà · Viladecans · No contracts" },
  },
  es: {
    nav: {
      serveis: "Servicios", comFunciona: "Cómo funciona", plans: "Planes", contacte: "Contacto", cta: "Hablemos",
    },
    hero: {
      badge: "Castelldefels · Gavà · Viladecans",
      h1: <>Cuando la tecnología<br/>puede ser<br/>un problema para ti,<br/>estamos <span style={{ color: "#D4E4F0" }}>nosotros</span><br/>para echarte<br/>una mano.</>,
      cta1: "Contáctanos", cta2: "Descubre más",
      cards: [
        { icon: "⚡", title: "Ahorra tiempo", desc: "Automatiza las tareas repetitivas de tu negocio." },
        { icon: "📱", title: "Controla tu espacio", desc: "Gestiona tu local desde el móvil, estés donde estés." },
        { icon: "🛡️", title: "Tranquilidad", desc: "Una persona de confianza cuando la tecnología falla." },
        { icon: "💬", title: "Comunícate", desc: "Tus clientes, siempre informados y conectados." },
      ],
    },
    about: {
      label: "Quiénes somos",
      h2: <>TechFels es una persona,<br/>no una empresa.</>,
      p1: "¿Tienes un problema tecnológico y no sabes a quién llamar? Trabajamos con negocios y hogares de Castelldefels, Gavà y Viladecans ayudándoles con todo lo tecnológico: desde un Excel que no funciona hasta la configuración completa de un local.",
      p2: "Somos tu interlocutor tecnológico de confianza. Siempre la misma persona, que conoce tu negocio y está cuando la necesitas.",
      tags: ["Sin contratos", "Sin permanencias", "Siempre cerca"],
    },
    services: {
      label: "Servicios", h2: "Tu negocio y tu espacio, bajo control.",
      closing: "Todo esto sin necesidad de entender demasiado de tecnología.",
      items: [
        { icon: "/icon_time.png", title: "Ahorra tiempo", desc: "Lo que haces manualmente cada día — recordatorios, seguimientos, envíos — lo automatizamos para que ocurra solo, sin que tengas que hacer nada." },
        { icon: "/icon_comm.png", title: "Comunícate", desc: "Tus clientes reciben la información que necesitan, en el momento adecuado. Sin esfuerzo por tu parte, y con una imagen profesional." },
        { icon: "/icon_control.png", title: "Controla tu espacio", desc: "Luz, música y temperatura adaptados al momento del día y a tu negocio. Todo desde el móvil, estés donde estés. Tus clientes lo notarán." },
        { icon: "/icon_tranquil.png", title: "Tranquilidad", desc: "Cuando algo falla, no tienes que buscar a quién llamar. Tienes una persona de confianza que conoce tu negocio y que está cuando la necesitas." },
      ],
    },
    how: {
      label: "Cómo funciona", h2: "Sencillo, transparente y sin sorpresas.",
      steps: [
        { n: "01", title: "Contacta", desc: "Llámanos, escríbenos o pásate sin compromiso." },
        { n: "02", title: "Explica", desc: "Te escuchamos y te proponemos la mejor solución para tu negocio o hogar." },
        { n: "03", title: "Tenemos la solución", desc: "Tú te olvidas, nosotros lo solucionamos." },
      ],
    },
    pricing: {
      label: "Planes", h2: "Apuesta por nosotros", sub: "Transparente y sin sorpresas",
      plans: [
        { name: "Por horas", detail: "Fracciones de 30 min · Sin compromiso previo", highlight: false },
        { name: "Bono de minutos", detail: "120 minutos prepagados · Ideal para tareas frecuentes", highlight: true },
        { name: "Proyecto cerrado", detail: "Precio acordado antes de empezar · Resultado garantizado", highlight: false },
      ],
      footer: "Sin permanencias",
    },
    cookies: {
  title: "Usamos cookies",
  text: "Utilizamos cookies propias y de terceros (Google Analytics) para analizar el tráfico y mejorar tu experiencia. Puedes aceptarlas o rechazarlas.",
  accept: "Aceptar",
  reject: "Rechazar",
  moreInfo: "Más información",
  privacyTitle: "Política de Privacidad y Cookies",
  privacyContent: `
    <h3>1. Responsable del tratamiento</h3>
    <p>TechFels · hola@techfels.es · Castelldefels, Barcelona</p>
    <h3>2. Finalidad</h3>
    <p>Los datos recogidos mediante el formulario de contacto se utilizan exclusivamente para responder tus consultas. No se ceden a terceros.</p>
    <h3>3. Cookies</h3>
    <p>Esta web utiliza Google Analytics (cookies analíticas) para obtener estadísticas anónimas de visitas. Solo se activan con tu consentimiento.</p>
    <h3>4. Derechos</h3>
    <p>Puedes ejercer tus derechos de acceso, rectificación, supresión y oposición escribiendo a hola@techfels.es.</p>
    <h3>5. Más información</h3>
    <p>Para más detalles escríbenos a hola@techfels.es.</p>
  `,
  close: "Cerrar",
},
    contact: {
      label: "Contacto", h2: "Hablemos.",
      sub: "Sin compromiso. Cuéntanos tu problema y te diremos cómo podemos ayudarte.",
      items: [
  { icon: "📞", label: "+34 684797403", sub: "Llámanos directamente", type: "phone" },
  { icon: "💬", label: "+34 684797403", sub: "WhatsApp", type: "whatsapp" },
  { icon: "✉️", label: "hola@techfels.es", sub: "Te respondemos en menos de 24h", type: "email" },
  { icon: "🌐", label: "www.techfels.es", sub: "Nuestra web", type: "web" },
  { icon: "📍", label: "Castelldefels · Gavà · Viladecans", sub: "Zona de servicio", type: null },
],
      formTitle: "Envíanos un mensaje", nameLabel: "Nombre", namePlaceholder: "Tu nombre",
      msgLabel: "Mensaje", msgPlaceholder: "Cuéntanos cómo podemos ayudarte...",
      submit: "Enviar mensaje", sending: "Enviando...",
      successTitle: "¡Mensaje enviado!", successSub: "Te responderemos pronto", errorMsg: "Rellena todos los campos",
      sendErrorMsg: "Ha habido un error al enviar. Por favor, inténtalo de nuevo.",

    },
    footer: { tagline: "Tecnología de proximidad", copy: "Castelldefels · Gavà · Viladecans · Sin contratos" },
  },
};

const LangContext = createContext({ lang: "ca", setLang: () => {} });
const useLang = () => useContext(LangContext);

function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setInView(true); },
      { threshold }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]); // eslint-disable-line react-hooks/exhaustive-deps
  return [ref, inView];
}

// ─── HOOK SECTION TRACKING ───────────────────────────────────────────────────
function useSectionTracking(sectionName, lang) {
  const ref = useRef(null);
  const tracked = useRef(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting && !tracked.current) {
          tracked.current = true;
          trackEvent("section_view", {
            event_category: "navegacion",
            event_label: sectionName,
            idioma: lang,
          });
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [sectionName, lang]);
  return ref;
}

function FadeIn({ children, delay = 0, className = "" }) {
  const [ref, inView] = useInView();
  return (
    <div ref={ref} className={className} style={{
      opacity: inView ? 1 : 0,
      transform: inView ? "translateY(0)" : "translateY(28px)",
      transition: `opacity 0.7s ease ${delay}s, transform 0.7s ease ${delay}s`,
    }}>{children}</div>
  );
}

function LangSelector() {
  const { lang, setLang } = useLang();
  return (
    <div style={{ display: "flex", alignItems: "center", background: "rgba(1,62,110,0.08)", borderRadius: 20, padding: 3, gap: 2, border: "1px solid rgba(1,62,110,0.18)" }}>
      {["ca", "es", "en"].map(l => (
        <button key={l} onClick={() => setLang(l)} style={{
          background: lang === l ? COLORS.dark : "transparent",
          color: lang === l ? "white" : COLORS.mid,
          border: "none", borderRadius: 16, padding: "5px 16px",
          fontFamily: "'Montserrat', sans-serif", fontSize: 12, fontWeight: 700,
          cursor: "pointer", transition: "all 0.2s", textTransform: "uppercase", letterSpacing: 0.8,
        }}>{l}</button>
      ))}
    </div>
  );
}

function Nav() {
  const { lang } = useLang();
  const isMobile = useIsMobile();
  const [menuOpen, setMenuOpen] = useState(false);
  const t = T[lang].nav;
  const links = [
    { label: t.serveis, href: "#serveis" },
    { label: t.comFunciona, href: "#com-funciona" },
    { label: t.plans, href: "#paquets" },
    { label: t.contacte, href: "#contacte" },
  ];
  return (
    <>
      <nav style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 100,
        background: "#E5E5E5", boxShadow: "0 2px 14px rgba(1,62,110,0.12)",
        padding: "0 5vw",
      }}>
        <div style={{
          maxWidth: 1200, margin: "0 auto",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          height: isMobile ? 80 : 140,
        }}>
          <a href="/" style={{ textDecoration: "none" }}>
            <img src="/logo.png" alt="TechFels logo" style={{ height: isMobile ? 56 : 120, width: "auto" }} />
          </a>

          {/* Desktop */}
          {!isMobile && (
            <div style={{ display: "flex", gap: 32, alignItems: "center" }}>
              {links.map(l => (
                <a key={l.href} href={l.href} style={{
                  color: COLORS.dark, textDecoration: "none",
                  fontFamily: "'Montserrat', sans-serif", fontSize: 16, fontWeight: 500,
                  transition: "color 0.2s",
                }}
                  onMouseEnter={e => e.target.style.color = COLORS.mid}
                  onMouseLeave={e => e.target.style.color = COLORS.dark}
                >{l.label}</a>
              ))}
              <LangSelector />
              <a href="#contacte" style={{
                background: COLORS.dark, color: "white", padding: "10px 24px", borderRadius: 24,
                fontFamily: "'Montserrat', sans-serif", fontSize: 14, fontWeight: 700,
                textDecoration: "none", transition: "background 0.2s",
              }}
                onClick={() => trackEvent("nav_cta_click", { event_category: "contacto", event_label: "nav_parlem" })}
                onMouseEnter={e => e.target.style.background = COLORS.mid}
                onMouseLeave={e => e.target.style.background = COLORS.dark}
              >{t.cta}</a>
            </div>
          )}

          {/* Mobile */}
          {isMobile && (
            <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
              <LangSelector />
              <button onClick={() => setMenuOpen(!menuOpen)} style={{
                background: "none", border: "none", cursor: "pointer",
                display: "flex", flexDirection: "column", gap: 5, padding: 8,
              }}>
                <span style={{ display: "block", width: 24, height: 2, background: COLORS.dark, borderRadius: 2, transition: "all 0.3s", transform: menuOpen ? "rotate(45deg) translateY(7px)" : "none" }}/>
                <span style={{ display: "block", width: 24, height: 2, background: COLORS.dark, borderRadius: 2, transition: "all 0.3s", opacity: menuOpen ? 0 : 1 }}/>
                <span style={{ display: "block", width: 24, height: 2, background: COLORS.dark, borderRadius: 2, transition: "all 0.3s", transform: menuOpen ? "rotate(-45deg) translateY(-7px)" : "none" }}/>
              </button>
            </div>
          )}
        </div>
      </nav>

      {/* Menú móvil desplegable */}
      {isMobile && (
        <div style={{
          position: "fixed", top: 80, left: 0, right: 0, zIndex: 99,
          background: "#E5E5E5",
          boxShadow: "0 8px 24px rgba(1,62,110,0.15)",
          padding: menuOpen ? "20px 6vw 28px" : "0 6vw",
          maxHeight: menuOpen ? 400 : 0,
          overflow: "hidden",
          transition: "max-height 0.3s ease, padding 0.3s ease",
        }}>
          {links.map(l => (
            <a key={l.href} href={l.href}
              onClick={() => setMenuOpen(false)}
              style={{
                display: "block", color: COLORS.dark, textDecoration: "none",
                fontFamily: "'Montserrat', sans-serif", fontSize: 18, fontWeight: 600,
                padding: "14px 0",
                borderBottom: `1px solid rgba(1,62,110,0.1)`,
              }}
            >{l.label}</a>
          ))}
          <a href="#contacte"
            onClick={() => { setMenuOpen(false); trackEvent("nav_cta_click", { event_category: "contacto", event_label: "nav_mobile_parlem" }); }}
            style={{
              display: "inline-block", marginTop: 20,
              background: COLORS.dark, color: "white",
              padding: "12px 28px", borderRadius: 24,
              fontFamily: "'Montserrat', sans-serif", fontSize: 15, fontWeight: 700,
              textDecoration: "none",
            }}
          >{t.cta}</a>
        </div>
      )}
    </>
  );
}

function Hero() {
  const { lang } = useLang();
  const isMobile = useIsMobile();
  const t = T[lang].hero;
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { setTimeout(() => setLoaded(true), 100); }, []);
  return (
    <section style={{
      minHeight: "100vh",
      background: `linear-gradient(135deg, ${COLORS.dark} 0%, #024d87 60%, #025a9e 100%)`,
      display: "flex", alignItems: "center",
      padding: isMobile ? "100px 6vw 60px" : "160px 5vw 60px",
      position: "relative", overflow: "hidden",
    }}>
      <div style={{ position: "absolute", top: -100, right: -100, width: 600, height: 600, borderRadius: "50%", background: "radial-gradient(circle, rgba(88,120,144,0.15) 0%, transparent 70%)", pointerEvents: "none" }}/>
      <div style={{
        maxWidth: 1200, margin: "0 auto", width: "100%",
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
        gap: isMobile ? 0 : 80,
        alignItems: "center",
      }}>
        <div style={{ opacity: loaded ? 1 : 0, transform: loaded ? "none" : "translateY(30px)", transition: "opacity 0.8s ease 0.1s, transform 0.8s ease 0.1s" }}>
          <div style={{ display: "inline-block", background: "rgba(212,228,240,0.12)", border: "1px solid rgba(212,228,240,0.25)", borderRadius: 20, padding: "6px 16px", marginBottom: 24 }}>
            <span style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 11, fontWeight: 600, color: COLORS.light, letterSpacing: 1.5, textTransform: "uppercase" }}>{t.badge}</span>
          </div>
          <h1 style={{
            fontFamily: "'Montserrat', sans-serif", fontWeight: 800,
            fontSize: isMobile ? "clamp(32px, 8vw, 44px)" : "clamp(36px, 4.5vw, 60px)",
            lineHeight: 1.08, color: "white", margin: "0 0 32px", letterSpacing: -1.5,
          }}>{t.h1}</h1>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <a href="#contacte" style={{
              background: "white", color: COLORS.dark,
              padding: isMobile ? "12px 24px" : "14px 32px",
              borderRadius: 30, fontFamily: "'Montserrat', sans-serif",
              fontSize: isMobile ? 14 : 15, fontWeight: 700,
              textDecoration: "none", boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
            }}
              onClick={() => trackEvent("hero_cta_click", { event_category: "contacto", event_label: "hero_contacta" })}
            >{t.cta1}</a>
            <a href="#serveis" style={{
              background: "transparent", color: "white",
              padding: isMobile ? "12px 24px" : "14px 32px",
              borderRadius: 30, fontFamily: "'Montserrat', sans-serif",
              fontSize: isMobile ? 14 : 15, fontWeight: 600,
              textDecoration: "none", border: "1.5px solid rgba(255,255,255,0.35)",
            }}>{t.cta2}</a>
          </div>
        </div>
        {!isMobile && (
          <div style={{ opacity: loaded ? 1 : 0, transform: loaded ? "none" : "translateX(30px)", transition: "opacity 0.9s ease 0.3s, transform 0.9s ease 0.3s" }}>
            <div style={{ background: "rgba(255,255,255,0.06)", backdropFilter: "blur(10px)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 24, padding: 40 }}>
              {t.cards.map((item, i) => (
                <div key={i} style={{ display: "flex", gap: 16, alignItems: "flex-start", padding: "16px 0", borderBottom: i < 3 ? "1px solid rgba(255,255,255,0.08)" : "none" }}>
                  <span style={{ fontSize: 22, flexShrink: 0, marginTop: 2 }}>{item.icon}</span>
                  <div>
                    <div style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, fontSize: 15, color: "white", marginBottom: 4 }}>{item.title}</div>
                    <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 13, color: "rgba(212,228,240,0.7)", lineHeight: 1.5 }}>{item.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

function About() {
  const { lang } = useLang();
  const isMobile = useIsMobile();
  const t = T[lang].about;
  const sectionRef = useSectionTracking("quienes_somos", lang);
  return (
    <section ref={sectionRef} style={{ background: "white", padding: isMobile ? "60px 6vw" : "100px 5vw" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <FadeIn>
          <div style={{ maxWidth: 720 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
              <div style={{ width: 40, height: 3, background: COLORS.mid, borderRadius: 2 }}/>
              <span style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 12, fontWeight: 700, color: COLORS.mid, letterSpacing: 2, textTransform: "uppercase" }}>{t.label}</span>
            </div>
            <h2 style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 800, fontSize: isMobile ? "clamp(24px, 6vw, 32px)" : "clamp(28px, 3vw, 44px)", color: COLORS.dark, margin: "0 0 24px", lineHeight: 1.1, letterSpacing: -0.5 }}>{t.h2}</h2>
            <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: isMobile ? 15 : 17, color: COLORS.text, lineHeight: 1.75, margin: "0 0 16px" }}>{t.p1}</p>
            <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: isMobile ? 15 : 17, color: COLORS.text, lineHeight: 1.75, margin: "0 0 32px" }}>{t.p2}</p>
            <div style={{ display: "flex", gap: isMobile ? 16 : 32, flexWrap: "wrap" }}>
              {t.tags.map(tag => (
                <div key={tag} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <div style={{ width: 8, height: 8, borderRadius: "50%", background: COLORS.mid, flexShrink: 0 }}/>
                  <span style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 13, fontWeight: 600, color: COLORS.dark }}>{tag}</span>
                </div>
              ))}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}

function Services() {
  const { lang } = useLang();
  const isMobile = useIsMobile();
  const t = T[lang].services;
  const sectionRef = useSectionTracking("serveis", lang);
  return (
    <section ref={sectionRef} id="serveis" style={{ background: COLORS.gray, padding: isMobile ? "60px 6vw" : "100px 5vw" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <FadeIn>
          <div style={{ textAlign: "center", marginBottom: isMobile ? 40 : 64 }}>
            <div style={{ display: "inline-flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
              <div style={{ width: 32, height: 3, background: COLORS.mid, borderRadius: 2 }}/>
              <span style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 12, fontWeight: 700, color: COLORS.mid, letterSpacing: 2, textTransform: "uppercase" }}>{t.label}</span>
              <div style={{ width: 32, height: 3, background: COLORS.mid, borderRadius: 2 }}/>
            </div>
            <h2 style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 800, fontSize: isMobile ? "clamp(22px, 5vw, 28px)" : "clamp(26px, 3vw, 40px)", color: COLORS.dark, margin: 0, letterSpacing: -0.5 }}>{t.h2}</h2>
          </div>
        </FadeIn>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fit, minmax(260px, 1fr))", gap: isMobile ? 16 : 24 }}>
          {t.items.map((s, i) => (
            <FadeIn key={s.title} delay={i * 0.1}>
              <div style={{
                background: "white", borderRadius: 20, overflow: "hidden",
                boxShadow: "0 2px 20px rgba(1,62,110,0.06)",
                transition: "transform 0.25s, box-shadow 0.25s",
                display: isMobile ? "flex" : "block",
                alignItems: isMobile ? "center" : "initial",
              }}
                onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = "0 12px 40px rgba(1,62,110,0.14)"; }}
                onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "0 2px 20px rgba(1,62,110,0.06)"; }}
              >
                <div style={{
                  background: COLORS.light,
                  width: isMobile ? 90 : "100%",
                  minWidth: isMobile ? 90 : "auto",
                  height: isMobile ? 90 : 160,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  overflow: "hidden", flexShrink: 0,
                }}>
                  {s.icon.startsWith("/")
                    ? <img src={s.icon} alt={s.title} style={{ width: isMobile ? 60 : 110, height: isMobile ? 60 : 110, objectFit: "contain" }} />
                    : <span style={{ fontSize: isMobile ? 36 : 56 }}>{s.icon}</span>
                  }
                </div>
                <div style={{ padding: isMobile ? "16px 20px" : "24px 28px 32px" }}>
                  <h3 style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, fontSize: isMobile ? 15 : 17, color: COLORS.dark, margin: "0 0 6px" }}>{s.title}</h3>
                  <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: isMobile ? 13 : 14, color: COLORS.text, lineHeight: 1.6, margin: 0 }}>{s.desc}</p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
        <FadeIn delay={0.4}>
          <p style={{ textAlign: "center", fontFamily: "'Montserrat', sans-serif", fontSize: isMobile ? 14 : 16, fontStyle: "italic", color: COLORS.mid, marginTop: isMobile ? 32 : 48 }}>{t.closing}</p>
        </FadeIn>
      </div>
    </section>
  );
}

function HowItWorks() {
  const { lang } = useLang();
  const isMobile = useIsMobile();
  const t = T[lang].how;
  const sectionRef = useSectionTracking("com_funciona", lang);
  return (
    <section ref={sectionRef} id="com-funciona" style={{ background: "white", padding: isMobile ? "60px 6vw" : "100px 5vw" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <FadeIn>
          <div style={{ textAlign: "center", marginBottom: isMobile ? 40 : 64 }}>
            <div style={{ display: "inline-flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
              <div style={{ width: 32, height: 3, background: COLORS.mid, borderRadius: 2 }}/>
              <span style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 12, fontWeight: 700, color: COLORS.mid, letterSpacing: 2, textTransform: "uppercase" }}>{t.label}</span>
              <div style={{ width: 32, height: 3, background: COLORS.mid, borderRadius: 2 }}/>
            </div>
            <h2 style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 800, fontSize: isMobile ? "clamp(22px, 5vw, 28px)" : "clamp(26px, 3vw, 40px)", color: COLORS.dark, margin: 0, letterSpacing: -0.5 }}>{t.h2}</h2>
          </div>
        </FadeIn>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)", gap: isMobile ? 32 : 40 }}>
          {t.steps.map((s, i) => (
            <FadeIn key={s.n} delay={i * 0.15}>
              <div style={{ display: "flex", gap: 20, alignItems: "flex-start" }}>
                <div style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 900, fontSize: isMobile ? 48 : 80, lineHeight: 1, color: COLORS.light, letterSpacing: -2, flexShrink: 0 }}>{s.n}</div>
                <div style={{ paddingTop: isMobile ? 4 : 12 }}>
                  <div style={{ width: 32, height: 3, background: COLORS.dark, borderRadius: 2, marginBottom: 12 }}/>
                  <h3 style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, fontSize: isMobile ? 17 : 22, color: COLORS.dark, margin: "0 0 8px" }}>{s.title}</h3>
                  <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: isMobile ? 14 : 15, color: COLORS.text, lineHeight: 1.65, margin: 0 }}>{s.desc}</p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}


function Pricing() {
  const { lang } = useLang();
  const isMobile = useIsMobile();
  const t = T[lang].pricing;
  const sectionRef = useSectionTracking("paquets", lang);
  return (
    <section ref={sectionRef} id="paquets" style={{ background: `linear-gradient(180deg, ${COLORS.gray} 0%, white 100%)`, padding: isMobile ? "60px 6vw" : "100px 5vw" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <FadeIn>
          <div style={{ textAlign: "center", marginBottom: isMobile ? 40 : 64 }}>
            <div style={{ display: "inline-flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
              <div style={{ width: 32, height: 3, background: COLORS.mid, borderRadius: 2 }}/>
              <span style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 12, fontWeight: 700, color: COLORS.mid, letterSpacing: 2, textTransform: "uppercase" }}>{t.label}</span>
              <div style={{ width: 32, height: 3, background: COLORS.mid, borderRadius: 2 }}/>
            </div>
            <h2 style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 800, fontSize: isMobile ? "clamp(22px, 5vw, 28px)" : "clamp(26px, 3vw, 40px)", color: COLORS.dark, margin: "0 0 12px", letterSpacing: -0.5 }}>{t.h2}</h2>
            <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 15, color: COLORS.textLight }}>{t.sub}</p>
          </div>
        </FadeIn>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)", gap: isMobile ? 16 : 24, maxWidth: isMobile ? "100%" : 900, margin: "0 auto" }}>
          {t.plans.map((p, i) => (
            <FadeIn key={p.name} delay={i * 0.12}>
              <div style={{
                background: p.highlight ? COLORS.dark : "white",
                borderRadius: 20,
                padding: isMobile ? "24px 24px" : "40px 32px",
                boxShadow: p.highlight ? "0 20px 60px rgba(1,62,110,0.3)" : "0 2px 20px rgba(1,62,110,0.08)",
                border: p.highlight ? "none" : `1.5px solid ${COLORS.light}`,
                transform: (!isMobile && p.highlight) ? "scale(1.04)" : "none",
                display: isMobile ? "flex" : "block",
                alignItems: isMobile ? "center" : "initial",
                justifyContent: isMobile ? "space-between" : "initial",
                textAlign: isMobile ? "left" : "center",
              }}>
                <div>
                  <h3 style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, fontSize: isMobile ? 15 : 17, color: p.highlight ? "white" : COLORS.dark, margin: isMobile ? "0 0 4px" : "0 0 24px" }}>{p.name}</h3>
                  <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 12, color: p.highlight ? "rgba(212,228,240,0.8)" : COLORS.textLight, lineHeight: 1.6, margin: 0 }}>{p.detail}</p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
        <FadeIn delay={0.4}>
          <p style={{ textAlign: "center", fontFamily: "'Montserrat', sans-serif", fontSize: 14, color: COLORS.mid, marginTop: isMobile ? 24 : 40, fontWeight: 600 }}>{t.footer}</p>
        </FadeIn>
      </div>
    </section>
  );
}

function Contact() {
  const { lang } = useLang();
  const isMobile = useIsMobile();
  const t = T[lang].contact;
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState(null);
  const sectionRef = useSectionTracking("contacte", lang);
  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!form.name || !form.email || !form.message) {
    setStatus("error-fields");
    return;
  }
  setStatus("sending");

  try {
    const res = await fetch('/api/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });

    if (res.ok) {
      setStatus("success");
      setForm({ name: "", email: "", message: "" });
      trackEvent("form_submit", { event_category: "contacto", event_label: "formulario_web", idioma: lang });
    } else {
      setStatus("error-send");
      trackEvent("form_error", { event_category: "contacto", event_label: "error_envio" });
    }
  } catch {
    setStatus("error-send");
  }
};
  return (
    <section ref={sectionRef} id="contacte" style={{ background: COLORS.dark, padding: isMobile ? "60px 6vw" : "100px 5vw" }}>
      <div style={{
        maxWidth: 1200, margin: "0 auto",
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
        gap: isMobile ? 40 : 80,
        alignItems: "start",
      }}>
        <FadeIn>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
              <div style={{ width: 40, height: 3, background: COLORS.light, borderRadius: 2 }}/>
              <span style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 12, fontWeight: 700, color: COLORS.light, letterSpacing: 2, textTransform: "uppercase" }}>{t.label}</span>
            </div>
            <h2 style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 800, fontSize: isMobile ? "clamp(28px, 7vw, 40px)" : "clamp(28px, 3vw, 44px)", color: "white", margin: "0 0 20px", letterSpacing: -0.5 }}>{t.h2}</h2>
            <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: isMobile ? 14 : 16, color: "rgba(212,228,240,0.75)", lineHeight: 1.7, margin: "0 0 32px" }}>{t.sub}</p>
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            {t.items.map((item) => {
              let href = null;
              if (item.type === "phone") href = `tel:${item.label.replace(/\s/g,"")}`;
              if (item.type === "whatsapp") href = `https://wa.me/${item.label.replace(/[^0-9]/g,"")}`;
              if (item.type === "email") href = `mailto:${item.label}`;
              if (item.type === "web") href = `https://${item.label}`;

              const inner = (
                <>
                  <div style={{ width: 40, height: 40, borderRadius: 10, background: "rgba(212,228,240,0.1)", border: "1px solid rgba(212,228,240,0.15)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, flexShrink: 0 }}>{item.icon}</div>
                  <div>
                    <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: isMobile ? 14 : 15, fontWeight: 600, color: "white", textDecoration: "none" }}>{item.label}</div>
                    <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 11, color: "rgba(212,228,240,0.55)" }}>{item.sub}</div>
                  </div>
                </>
              );

              return href ? (
                <a key={item.label} href={href} target={item.type === "web" ? "_blank" : undefined} rel="noreferrer"
                  onClick={() => {
                    if (item.type === "whatsapp") trackEvent("whatsapp_click", { event_category: "contacto", event_label: "whatsapp" });
                    if (item.type === "phone") trackEvent("phone_click", { event_category: "contacto", event_label: "telefono" });
                    if (item.type === "email") trackEvent("email_click", { event_category: "contacto", event_label: "email" });
                  }}
                  style={{ display: "flex", gap: 14, alignItems: "center", textDecoration: "none", cursor: "pointer" }}>
                  {inner}
                </a>
              ) : (
                <div key={item.label} style={{ display: "flex", gap: 14, alignItems: "center" }}>
                  {inner}
                </div>
              );
            })}
            </div>
          </div>
        </FadeIn>
        <FadeIn delay={0.2}>
          <div style={{ background: "rgba(255,255,255,0.05)", backdropFilter: "blur(10px)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 24, padding: isMobile ? 24 : 40 }}>
            <h3 style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 700, fontSize: isMobile ? 17 : 20, color: "white", margin: "0 0 24px" }}>{t.formTitle}</h3>
            {status === "success" ? (
              <div style={{ textAlign: "center", padding: "40px 0" }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
                <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 16, color: COLORS.light, fontWeight: 600 }}>{t.successTitle}</p>
                <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 14, color: "rgba(212,228,240,0.6)" }}>{t.successSub}</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                {[
                  { id: "name", label: t.nameLabel, type: "text", placeholder: t.namePlaceholder },
                  { id: "email", label: "Email", type: "email", placeholder: "hola@exemple.com" },
                ].map(field => (
                  <div key={field.id}>
                    <label style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 12, fontWeight: 600, color: "rgba(212,228,240,0.7)", display: "block", marginBottom: 6, letterSpacing: 0.5 }}>{field.label}</label>
                    <input type={field.type} placeholder={field.placeholder} value={form[field.id]} onChange={e => setForm({ ...form, [field.id]: e.target.value })}
                      style={{ width: "100%", boxSizing: "border-box", background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 12, padding: "12px 14px", fontFamily: "'Montserrat', sans-serif", fontSize: 14, color: "white", outline: "none", transition: "border-color 0.2s" }}
                      onFocus={e => e.target.style.borderColor = "rgba(212,228,240,0.5)"}
                      onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.12)"}
                    />
                  </div>
                ))}
                  <div>
                    <label style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 12, fontWeight: 600, color: "rgba(212,228,240,0.7)", display: "block", marginBottom: 6, letterSpacing: 0.5 }}>{t.msgLabel}</label>
                    <textarea
                      placeholder={t.msgPlaceholder}
                      value={form.message}
                      onChange={e => setForm({ ...form, message: e.target.value.slice(0, 2000) })}
                      rows={4}
                      maxLength={2000}
                      style={{ width: "100%", boxSizing: "border-box", background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 12, padding: "12px 14px", fontFamily: "'Montserrat', sans-serif", fontSize: 14, color: "white", outline: "none", resize: "vertical", transition: "border-color 0.2s" }}
                      onFocus={e => e.target.style.borderColor = "rgba(212,228,240,0.5)"}
                      onBlur={e => e.target.style.borderColor = "rgba(255,255,255,0.12)"}
                    />
                    <div style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: 6,
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: 11,
                      color: form.message.length > 1800 ? "#ff8a8a" : "rgba(212,228,240,0.4)",
                      transition: "color 0.2s",
                    }}>
                      {form.message.length} / 2000
                    </div>
                  </div>
                {status === "error" && <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 13, color: "#ff8a8a", margin: 0 }}>{t.errorMsg}</p>}
                <button type="submit" disabled={status === "sending"}
                  style={{ background: status === "sending" ? COLORS.mid : "white", color: COLORS.dark, border: "none", borderRadius: 12, padding: "14px 28px", fontFamily: "'Montserrat', sans-serif", fontSize: 15, fontWeight: 700, cursor: status === "sending" ? "wait" : "pointer", transition: "background 0.2s", marginTop: 4 }}
                  onMouseEnter={e => { if (status !== "sending") e.target.style.background = COLORS.light; }}
                  onMouseLeave={e => { e.target.style.background = "white"; }}
                >{status === "sending" ? t.sending : t.submit}</button>
              </form>
            )}
          </div>
        </FadeIn>
      </div>
    </section>
  );
}

function Footer() {
  const { lang } = useLang();
  const isMobile = useIsMobile();
  const t = T[lang].footer;

  const getPrivacyLink = () => {
    if (lang === 'ca') return '/privacy-ca.html';
    if (lang === 'en') return '/privacy-en.html';
    return '/privacy.html'; // Spanish default
  };

  const getTermsLink = () => {
    if (lang === 'ca') return '/terms-ca.html';
    if (lang === 'en') return '/terms-en.html';
    return '/terms-es.html'; // Spanish default
  };

  return (
    <footer style={{ background: "#011f3a", padding: "24px 5vw" }}>
      <div style={{
        maxWidth: 1200, margin: "0 auto",
        display: "flex", flexDirection: isMobile ? "column" : "row",
        justifyContent: "space-between", alignItems: isMobile ? "flex-start" : "center", gap: 12,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img src="/logo.png" alt="TechFels" style={{ height: isMobile ? 28 : 40, width: "auto", filter: "brightness(0) invert(1) opacity(0.7)" }} />
          <span style={{ color: "rgba(255,255,255,0.3)", fontSize: 12 }}>·</span>
          <span style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 12, color: "rgba(255,255,255,0.4)" }}>{t.tagline}</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
          <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 11, color: "rgba(255,255,255,0.35)" }}>{t.copy}</div>
          <a href={getTermsLink()} style={{
            background: "none", border: "none", fontFamily: "'Montserrat', sans-serif",
            fontSize: 11, color: "rgba(255,255,255,0.35)", cursor: "pointer",
            textDecoration: "underline", padding: 0,
          }}>
            {lang === 'ca' ? 'Termes i condicions' : lang === 'es' ? 'Términos y condiciones' : 'Terms & conditions'}
          </a>
          <a href={getPrivacyLink()} style={{
            background: "none", border: "none", fontFamily: "'Montserrat', sans-serif",
            fontSize: 11, color: "rgba(255,255,255,0.35)", cursor: "pointer",
            textDecoration: "underline", padding: 0,
          }}>
            {lang === 'ca' ? 'Política de cookies' : lang === 'es' ? 'Política de cookies' : 'Cookie policy'}
          </a>
          <button onClick={() => { localStorage.removeItem('cookieConsent'); window.location.reload(); }} style={{
            background: "none", border: "none", fontFamily: "'Montserrat', sans-serif",
            fontSize: 11, color: "rgba(255,255,255,0.25)", cursor: "pointer",
            textDecoration: "underline", padding: 0,
          }}>
            {lang === 'ca' ? 'Gestionar cookies' : lang === 'es' ? 'Gestionar cookies' : 'Manage cookies'}
          </button>
        </div>
      </div>
    </footer>
  );
}

function CookieBanner() {
  const { lang } = useLang();
  const isMobile = useIsMobile();
  const t = T[lang].cookies;
  const [status, setStatus] = useState(() => localStorage.getItem('cookieConsent'));

  const getPrivacyLink = () => {
    if (lang === 'ca') return '/privacy-ca.html';
    if (lang === 'en') return '/privacy-en.html';
    return '/privacy.html'; // Spanish default
  };

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setStatus('accepted');
    if (window.loadGA) window.loadGA();
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setStatus('rejected');
  };

  if (status) return null;

  return (
    <>
      <div style={{
        position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 200,
        background: "#011f3a", borderTop: "1px solid rgba(212,228,240,0.15)",
        padding: isMobile ? "20px 6vw" : "20px 5vw",
        boxShadow: "0 -4px 24px rgba(0,0,0,0.3)",
      }}>
        <div style={{
          maxWidth: 1200, margin: "0 auto",
          display: "flex", flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "flex-start" : "center",
          gap: isMobile ? 16 : 32, justifyContent: "space-between",
        }}>
          <div style={{ flex: 1 }}>
            <p style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 13, color: "rgba(212,228,240,0.9)", lineHeight: 1.6, margin: 0 }}>
              <strong style={{ color: "white" }}>{t.title}.</strong> {t.text}{" "}
              <a href={getPrivacyLink()} style={{
                background: "none", border: "none", color: COLORS.light,
                fontFamily: "'Montserrat', sans-serif", fontSize: 13,
                textDecoration: "underline", cursor: "pointer", padding: 0,
              }}>{t.moreInfo}</a>
            </p>
          </div>
          <div style={{ display: "flex", gap: 10, flexShrink: 0 }}>
            <button onClick={handleReject} style={{
              background: "transparent", color: "rgba(212,228,240,0.7)",
              border: "1px solid rgba(212,228,240,0.3)", borderRadius: 20,
              padding: "9px 20px", fontFamily: "'Montserrat', sans-serif",
              fontSize: 13, fontWeight: 600, cursor: "pointer",
            }}>{t.reject}</button>
            <button onClick={handleAccept} style={{
              background: "white", color: COLORS.dark, border: "none", borderRadius: 20,
              padding: "9px 20px", fontFamily: "'Montserrat', sans-serif",
              fontSize: 13, fontWeight: 700, cursor: "pointer",
            }}>{t.accept}</button>
          </div>
        </div>
      </div>
    </>
  );
}

export default function TechFelsApp() {
  const [lang, setLang] = useState("ca");
  return (
    <LangContext.Provider value={{ lang, setLang }}>
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800;900&display=swap" rel="stylesheet"/>
      <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        html { scroll-behavior: smooth; }
        body { background: #013E6E; }
        input::placeholder, textarea::placeholder { color: rgba(255,255,255,0.35) !important; }
      `}</style>
      <Nav />
      <main>
        <Hero />
        <About />
        <Services />
        <HowItWorks />
        <Pricing />
        <Contact />
      </main>
      <Footer />
      <CookieBanner />

    </LangContext.Provider>
  );
}